import { Box, Modal } from "@mui/material";
import React from "react";
import cssClasses from "./FileManager.module.css";
import downloadIcon from "../../Assets/Images/Common/download.svg";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useState } from "react";
import { useEffect } from "react";
import { errorTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { downloadPreviewAggrementConfirmationDocFile } from "../../Services/Drive";
import Button from "../../Subcomponents/Button";

export default function PreviewAggrementImageModal({
  open,
  handleClose,
  value,
  title
}) {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    if (typeof value === "object") {
      setDocs([{ uri: window.URL.createObjectURL(value), fileName: value.name }]);
    } else {
      setDocs([{ uri: value }]);
    }
  }, [value]);

  const handleDownloadFile = () => {
    presentLoader();
    downloadPreviewAggrementConfirmationDocFile(value?.split("AgreementKYCDocuments/")[1])
        .then((val) => {
          dismissLoader();
          // const a = document.createElement("a");
          // a.href = URL.createObjectURL(
          //   new Blob([JSON.stringify(val?.data, null, 2)], {
          //     type: val?.data?.type,
          //   })
          // );
          // a.setAttribute("download", value?.fileName);
          // document.body.appendChild(a);
          // a.click();
          // document.body.removeChild(a);

          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(val?.data);
          link.download = `${value?.fileName}`;
          link.click();
        })
        .catch((err) => {
          errorTost(err.message);
          dismissLoader();
        });
      
  };
  return (
    <Modal
      open={open}
      onClose={() => handleClose({ flag: false })}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box
        className={cssClasses.modalWrapper}
        style={{ width: " min(1000px, 90%)", padding: "30px" }}
      >
        <div className={cssClasses.mainContainer}>
          <Box className={cssClasses.inputContainer}>
            <div style={{ display: "flex", alignItems: "center", gap: "4rem" }}>
            <p style={{ fontSize: "20px", marginBottom: "10px" , fontWeight:"900"}}>
                  {title}
                </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "2rem" }}
              >
                <p style={{ fontSize: "14px", marginBottom: "10px" , color:"gray" }}>
                  {value?.name}
                </p>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
              <img
                src={downloadIcon}
                alt="download"
                onClick={() => handleDownloadFile()}
                style={{ cursor: "pointer" }}
              />
              
            </div>
          </Box>
          <div>
            <DocViewer
              documents={docs}
              pluginRenderers={DocViewerRenderers}
              style={{ height: "600px" ,opacity:0.7}}
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
              style={{
                color: "#000",
                backgroundColor: "#fff",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Inter-Medium !important",
                width: "20%",
              }}
              btnName={"Cancel"}
              clicked={() => {
                handleClose();
              }}
            />
        </div>
        
      </Box>
      
    </Modal>
  );
}
